/**
 * Replicates `eq` from ember-truth-helpers
 * https://www.npmjs.com/package/ember-truth-helpers
 */
export function eq(a: unknown, b: unknown): boolean {
  return a === b;
}
